function appRunQueryStringInterceptor($rootScope, $location) {
    "ngInject";
    var locationSearch;

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        //save location.search so we can add it back after transition is done
        locationSearch = $location.search();
    });

    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        //restore all query string parameters back to $location.search
        $location.search(locationSearch);
    });
}

export default appRunQueryStringInterceptor;



// WEBPACK FOOTER //
// ./client/app/app.run.queryStringInterceptor.js